import type { Language } from "../../../shared/const";

const TW_TZ = "Asia/Taipei";

export function fmtCurrency(amount: number | string | null | undefined, currency: "TWD" | "HKD" | "USD") {
  if (amount === null || amount === undefined || amount === "") return "—";
  const v = typeof amount === "string" ? Number(amount) : amount;
  if (Number.isNaN(v)) return "—";
  return new Intl.NumberFormat("zh-Hant", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(v);
}

export function fmtNumber(amount: number | string | null | undefined) {
  if (amount === null || amount === undefined || amount === "") return "—";
  const v = typeof amount === "string" ? Number(amount) : amount;
  if (Number.isNaN(v)) return "—";
  return new Intl.NumberFormat("zh-Hant").format(v);
}

export function fmtDateTime(ts: number | Date | null | undefined, lang: Language = "zh-TW") {
  if (!ts) return "—";
  const d = ts instanceof Date ? ts : new Date(ts);
  return new Intl.DateTimeFormat(lang === "en-US" ? "en-US" : "zh-Hant", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: TW_TZ,
  }).format(d);
}

export function fmtDate(ts: number | Date | null | undefined, lang: Language = "zh-TW") {
  if (!ts) return "—";
  const d = ts instanceof Date ? ts : new Date(ts);
  return new Intl.DateTimeFormat(lang === "en-US" ? "en-US" : "zh-Hant", {
    dateStyle: "medium",
    timeZone: TW_TZ,
  }).format(d);
}

export function fmtRelative(ts: number | Date | null | undefined): string {
  if (!ts) return "—";
  const t = ts instanceof Date ? ts.getTime() : ts;
  const diff = Date.now() - t;
  const abs = Math.abs(diff);
  const sign = diff >= 0 ? "前" : "後";
  if (abs < 60_000) return "剛剛";
  if (abs < 3600_000) return `${Math.floor(abs / 60_000)} 分鐘${sign}`;
  if (abs < 86_400_000) return `${Math.floor(abs / 3600_000)} 小時${sign}`;
  return `${Math.floor(abs / 86_400_000)} 天${sign}`;
}

/** datetime-local input <-> unix ms helpers（用本機時區） */
export function toLocalInput(ts: number): string {
  const d = new Date(ts);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function fromLocalInput(v: string): number {
  return new Date(v).getTime();
}
